<template>
  <section class="main">
    <article class="art-sec">
      <p class="title">凭证信息</p>
      <div class="cont-box">
        <div class="cont-item">
          <span class="left">凭证编号：</span
          ><span class="right">{{ formData.hzbh || "--" }}</span>
        </div>
        <div class="cont-item">
          <span class="left">交存时间：</span
          ><span class="right">{{ formData.jcsj || "--" }}</span>
        </div>
        <div class="cont-item">
          <span class="left left-white">交款人：</span
          ><span class="right">{{ formData.jcr || "--" }}</span>
        </div>
        <div class="cont-item">
          <span class="left">交存金额：</span
          ><span class="right">{{ (formData.jcje || "--") + "&nbsp;元" }}</span>
        </div>
        <div class="cont-item">
          <span class="left">代管机构：</span
          ><span class="right">{{ formData.dgjg || "--" }}</span>
        </div>
        <div class="cont-item">
          <span class="left">专户银行：</span
          ><span class="right">{{ formData.zhyhmc || "--" }}</span>
        </div>
        <div class="cont-item">
          <span class="left">查阅次数：</span
          ><span :class="['right', muchLook ? 'muchLook' : '']">{{
            (formData.frequency || "--") + "&nbsp;次"
          }}</span>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import { sendemail, voucherInfo } from "@api/deposite.js";
import getChinaNumb from "../utils/moneyFormat";
export default {
  data() {
    return {
      muchLook: false,
      formData: {},
    };
  },
  methods: {
    serchInfo() {
      voucherInfo({
        tzdId: this.$route.query.tzdid,
        tenantId: this.$route.query.tenantId,
      })
        .then(({ data: { code, data: innerData } }) => {
          if (code == 200) {
            this.formData = innerData;
            this.muchLook = innerData.frequency >= 10;
          } else {
            return this.$toast({
              message: "查询失败，请稍后重试！",
              position: "top",
            });
          }
        })
        .catch(() => {
          return this.$toast({
            message: "查询失败，请稍后重试！",
            position: "top",
          });
        });
    },
  },
  mounted() {
    // if (!this.$route.query.tzdid) {
    //   this.$router.push("/proofDetail?tzdid=80000000073959");
    // }
    this.serchInfo();
  },
  created() {},
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "icomoon";
  src: url("../assets/fonts/icomoon.eot?3jk4dz");
  src: url("../assets/fonts/icomoon.eot?3jk4dz#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/icomoon.ttf?3jk4dz") format("truetype"),
    url("../assets/fonts/icomoon.woff?3jk4dz") format("woff"),
    url("../assets/fonts/icomoon.svg?3jk4dz#icomoon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

.main {
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 60px 60px 0 60px;

  background-color: #fff;

  .art-sec {
    p.title {
      margin-bottom: 40px;
      text-align: center;
      font-size: 24px;
      font-weight: 650;
      color: rgb(60, 59, 59);
    }

    .cont-item {
      display: flex;
      margin-bottom: 14px;
      line-height: 24px;

      .left {
        width: 84px;
        color: #999;
      }

      .right {
        flex: 1;
      }

      .left-white {
        letter-spacing: 5px;
        white-space: nowrap;
      }
    }

    .muchLook {
      position: relative;

      &::after {
        content: "凭证二维码查阅次数较多，请注意凭证信息安全问题！";
        position: absolute;
        top: 24px;
        left: 0;
        color: #e04040;
        text-indent: 0;
      }
    }
  }
}
</style>
